/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFrameOff = createReactComponent("outline", "frame-off", "IconFrameOff", [["path", { "d": "M4 7h3m4 0h9", "key": "svg-0" }], ["path", { "d": "M4 17h13", "key": "svg-1" }], ["path", { "d": "M7 7v13", "key": "svg-2" }], ["path", { "d": "M17 4v9m0 4v3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconFrameOff as default };
//# sourceMappingURL=IconFrameOff.mjs.map
